// extracted by mini-css-extract-plugin
export default {"header":"styles_header__YU8Zn","smallScreen":"styles_smallScreen__YoLP1"};